import request from '@/utils/request'

// 投放组列表123
export function getReleaseGroupList(params = {}) {
  return request({
    url: '/channel_release_report/channel_release_group',
    method: 'get',
    params
  })
}

// 投放组列表123--小说报表
export function getReleaseGroupListNovel(params = {}) {
  return request({
    url: '/novel_mini_release_report/channel_release_group',
    method: 'get',
    params
  })
}
// 投放组列表123--小说站点
export function getReleaseGroupListNovelSite(params = {}) {
  return request({
    url: '/novel_mini_release_report/site/channel_release_group',
    method: 'get',
    params
  })
}
// 添加投放组123
export function addReleaseGroup(data = {}) {
  return request({
    url: '/channel_release_report/channel_release_group',
    method: 'post',
    data
  })
}

// 投放组修改123
export function updateReleaseGroup(data = {}) {
  return request({
    url: `/channel_release_report/channel_release_group/${data.id}`,
    method: 'PUT',
    data
  })
}
// 添加投放组123---小说
export function addReleaseGroupNovel(data = {}) {
  return request({
    url: '/novel_mini_release_report/channel_release_group',
    method: 'post',
    data
  })
}

// 投放组修改123--小说
export function updateReleaseGroupNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/channel_release_group/${data.id}`,
    method: 'PUT',
    data
  })
}
// 删除投放组123
export function deleteMy(id) {
  return request({
    url: `/channel_release_report/channel_release_group/${id}`,
    method: 'delete'
  })
}
// 删除投放组123--小说
export function deleteMyNovel(id) {
  return request({
    url: `/novel_mini_release_report/channel_release_group/${id}`,
    method: 'delete'
  })
}
// 投放组投手列表123
export function getListOfPitchersInTheLaunchGroup(params = {}) {
  return request({
    url: `/channel_release_report/release_group_user`,
    method: 'get',
    params
  })
}
// 投放组投手列表123---小说
export function getListOfPitchersInTheLaunchGroupNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/release_group_user`,
    method: 'get',
    params
  })
}
// 投放组投手列表123---小说站点
export function getListOfPitchersInTheLaunchGroupNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/release_group_user`,
    method: 'get',
    params
  })
}

// 添加投放组投手123
export function addOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/channel_release_report/release_group_user_add`,
    method: 'post',
    data
  })
}
// 添加投放组投手123=---小说
export function addOfPitchersInTheLaunchGroupNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/release_group_user_add`,
    method: 'post',
    data
  })
}

// 删除投放组投手123
export function deleteOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/channel_release_report/release_group_user_del`,
    method: 'DELETE',
    data
  })
}
// 删除投放组投手123===小说
export function deleteOfPitchersInTheLaunchGroupNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/release_group_user_del`,
    method: 'DELETE',
    data
  })
}
// 获取小说列表123?(报错)
export function getFictionList(params = {}) {
  return request({
    url: `/channel_release_report/novel_list`,
    method: 'get',
    params
  })
}
// 获取小说列表123?(报错)
export function getFictionListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/novel_list`,
    method: 'get',
    params
  })
}

// 获取书籍归属列表123
export function getBookOwnershipList(params = {}) {
  return request({
    url: `/channel_release_report/belong_list`,
    method: 'get',
    params
  })
}
// 获取书籍归属列表123--小说报表的
export function getBookOwnershipListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/belong_list`,
    method: 'get',
    params
  })
}
// 获取书籍归属列表123--小说站点
export function getBookOwnershipListNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/belong_list`,
    method: 'get',
    params
  })
}
// 添加书籍归属123
export function addBookOwnership(data = {}) {
  return request({
    url: `/channel_release_report/add_belong_book`,
    method: 'post',
    data
  })
}

// 修改书籍归属123？(归属书籍不存在？)
export function modifyBookOwnership(data = {}) {
  return request({
    url: `/channel_release_report/update_belong_book`,
    method: 'PUT',
    data
  })
}
// 添加书籍归属123--小说
export function addBookOwnershipNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/add_belong_book`,
    method: 'post',
    data
  })
}

// 修改书籍归属123？(归属书籍不存在？)--小说
export function modifyBookOwnershipNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/update_belong_book`,
    method: 'PUT',
    data
  })
}
// 删除书籍归属123
export function deleteBooks(id) {
  return request({
    url: `/channel_release_report/del_belong_book?id=${id}`,
    method: 'delete'
  })
}
// 删除书籍归属123---小说
export function deleteBooksNovel(id) {
  return request({
    url: `/novel_mini_release_report/del_belong_book?id=${id}`,
    method: 'delete'
  })
}

// 获取书名列表
export function getTitleList(params = {}) {
  return request({
    url: `/channel_release_report/book_alias_list`,
    method: 'get',
    params
  })
}
// 获取书名列表
export function getTitleListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/book_alias_list`,
    method: 'get',
    params
  })
}
// 获取书名列表  站点
export function getTitleListNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/book_alias_list`,
    method: 'get',
    params
  })
}
// 小说绑定书籍归属123
export function novelsBoundToBooks(data = {}) {
  return request({
    url: `/channel_release_report/add_alias`,
    method: 'post',
    data
  })
}
// 小说绑定书籍归属123---小说
export function novelsBoundToBooksNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/add_alias`,
    method: 'post',
    data
  })
}

// 删除小说绑定书籍归属123
export function deleteNovelsBoundToBooks(data = {}) {
  return request({
    url: `/channel_release_report/del_alias`,
    method: 'DELETE',
    data
  })
}
// 删除小说绑定书籍归属123---小说
export function deleteNovelsBoundToBooksNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/del_alias`,
    method: 'DELETE',
    data
  })
}

// 投放位置列表123(报错)
export function dropLocationList(params = {}) {
  return request({
    url: `/channel_release_report/channel_positions`,
    method: 'get',
    params
  })
}

// 投放位置列表123(报错)---小说
export function dropLocationListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/channel_positions`,
    method: 'get',
    params
  })
}
// 投放位置列表123(报错)---小说站点
export function dropLocationListNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/channel_positions`,
    method: 'get',
    params
  })
}
// 添加投放位置123
export function addDropLocationList(data = {}) {
  return request({
    url: `/channel_release_report/channel_positions`,
    method: 'post',
    data
  })
}

// 修改投放位置123？
export function modifyDropLocationList(data = {}) {
  return request({
    url: `/channel_release_report/channel_positions/${data.id}`,
    method: 'put',
    data
  })
}
// 添加投放位置123---小说
export function addDropLocationListNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/channel_positions`,
    method: 'post',
    data
  })
}

// 修改投放位置123？---小说
export function modifyDropLocationListNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/channel_positions/${data.id}`,
    method: 'put',
    data
  })
}

// 获取绑定关系列表123
export function getBindingRelationList(params = {}) {
  return request({
    url: `/channel_release_report/bind_channel`,
    method: 'get',
    params
  })
}
// 获取绑定关系列表123--小说
export function getBindingRelationListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/bind_channel`,
    method: 'get',
    params
  })
}
// 获取绑定关系列表123--小说站点
export function getBindingRelationSiteListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/bind_channel`,
    method: 'get',
    params
  })
}

// // 获取渠道号列表123
export function getTheListOfOfficialAccount(params = {}) {
  return request({
    url: `/channel_release_report/channel_list`,
    method: 'get',
    params
  })
}
// // 获取渠道号列表123小说
export function getTheListOfOfficialAccountNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/channel_list`,
    method: 'get',
    params
  })
}
// // 获取渠道号列表123--小说站点
export function getTheListOfOfficialAccountNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/channel_list`,
    method: 'get',
    params
  })
}
// // 获取广告主123
export function getAdvertiser(params = {}) {
  return request({
    url: `/channel_release_report/advertiser_list`,
    method: 'get',
    params
  })
}
// // 获取广告主123
export function getAdvertiserNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/advertiser_list`,
    method: 'get',
    params
  })
}
// // 获取广告主123-小说站点
export function getAdvertiserNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/advertiser_list`,
    method: 'get',
    params
  })
}
// 添加投放关系123
export function addReleaseRelationship(data = {}) {
  return request({
    url: `/channel_release_report/bind_channel`,
    method: 'post',
    data
  })
}

// 添加投放关系123
export function addReleaseRelationshipNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/bind_channel`,
    method: 'post',
    data
  })
}
// 添加投放关系123
export function addReleaseRelationshipNovelSite(data = {}) {
  return request({
    url: `/novel_mini_release_report/site/bind_channel`,
    method: 'post',
    data
  })
}

// 修改投放关系123
export function modifyReleaseRelationship(id, data = {}) {
  return request({
    url: `/channel_release_report/bind_channel/${id}`,
    method: 'put',
    data
  })
}

// 修改投放关系123--小说
export function modifyReleaseRelationshipNovel(id, data = {}) {
  return request({
    url: `/novel_mini_release_report/bind_channel/${id}`,
    method: 'put',
    data
  })
}
// 修改投放关系123--小说站点
export function modifyReleaseRelationshipNovelSite(id, data = {}) {
  return request({
    url: `/novel_mini_release_report/site/bind_channel/${id}`,
    method: 'put',
    data
  })
}

// 删除投放关系123
export function deleteReleaseRelationship(id) {
  return request({
    url: `/channel_release_report/bind_channel/${id}`,
    method: 'DELETE'
  })
}

// 删除投放关系123
export function deleteReleaseRelationshipNovle(id) {
  return request({
    url: `/novel_mini_release_report/bind_channel/${id}`,
    method: 'DELETE'
  })
}
// 删除投放关系123站点
export function deleteReleaseRelationshipNovleSite(id) {
  return request({
    url: `/novel_mini_release_report/site/bind_channel/${id}`,
    method: 'DELETE'
  })
}
// 获取报表列表123
export function getReportList(params = {}) {
  return request({
    url: `/channel_release_report/bind_channel_report`,
    method: 'get',
    params
  })
}
// 获取报表列表123---小说
export function getReportListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/bind_channel_report`,
    method: 'get',
    params
  })
}
// 获取报表列表123---小说站点
export function getReportListNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/bind_channel_report`,
    method: 'get',
    params
  })
}

// 导出报表123
export function exportReport(data = {}) {
  return request({
    url: `/channel_release_report/export_bind_data`,
    method: 'post',
    data
  })
}
// 导出报表123--小说
export function exportReportNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/export_bind_data`,
    method: 'post',
    data
  })
}
// 导出报表123--小说站点
export function exportReportNovelsite(data = {}) {
  return request({
    url: `/novel_mini_release_report/site/export_bind_data`,
    method: 'post',
    data
  })
}

// 修改消耗123
export function modifyConsumption(data = {}) {
  return request({
    url: `/channel_release_report/edit_consume`,
    method: 'PUT',
    data
  })
}
// 修改消耗123---小说
export function modifyConsumptionNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/edit_consume`,
    method: 'PUT',
    data
  })
}
// 修改消耗123---小说站点
export function modifyConsumptionNovelSite(data = {}) {
  return request({
    url: `/novel_mini_release_report/site/edit_consume`,
    method: 'PUT',
    data
  })
}

// 获取总计报表列表123
export function getTotalReportList(params = {}) {
  return request({
    url: `/channel_release_report/bind_channel_total_report`,
    method: 'get',
    params
  })
}
// 获取总计报表列表123 ----小说
export function getTotalReportListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/bind_channel_total_report`,
    method: 'get',
    params
  })
}
// 获取总计报表列表123 ----小说站点
export function getTotalReportListNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/bind_channel_total_report`,
    method: 'get',
    params
  })
}

// 导出总计报表123
export function exportTotalReport(data = {}) {
  return request({
    url: `/channel_release_report/export_bind_total_data`,
    method: 'POST',
    data
  })
}
// 导出总计报表123--小说
export function exportTotalReportNovle(data = {}) {
  return request({
    url: `/novel_mini_release_report/export_bind_total_data`,
    method: 'POST',
    data
  })
}
// 导出总计报表123--小说站点
export function exportTotalReportNovleSite(data = {}) {
  return request({
    url: `/novel_mini_release_report/site/export_bind_total_data`,
    method: 'POST',
    data
  })
}

// 获取平台123
export function getPlatform(params = {}) {
  return request({
    url: `/common/specific_platform_list`,
    method: 'get',
    params
  })
}

// T图列表123
export function tFigureList(params = {}) {
  return request({
    url: `/channel_release_report/bind_channel_t_report`,
    method: 'get',
    params
  })
}
// T图列表123--小说
export function tFigureListNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/bind_channel_t_report`,
    method: 'get',
    params
  })
}
// T图列表123--小说站点
export function tFigureListNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/bind_channel_t_report`,
    method: 'get',
    params
  })
}
// 导出T图列表123
export function exportTFigureList(data = {}) {
  return request({
    url: `/channel_release_report/export_bind_t_data`,
    method: 'post',
    data
  })
}
// 导出T图列表123---小说
export function exportTFigureListNovel(data = {}) {
  return request({
    url: `/novel_mini_release_report/export_bind_t_data`,
    method: 'post',
    data
  })
}
// 导出T图列表123---小说站点
export function exportTFigureListNovelSite(data = {}) {
  return request({
    url: `/novel_mini_release_report/site/export_bind_t_data`,
    method: 'post',
    data
  })
}

// 更新123
export function toUpdate(params = {}) {
  return request({
    url: `channel_release_report/bind_channel_t_report_update`,
    method: 'get',
    params
  })
}
// 更新123---小说
export function toUpdateNovel(params = {}) {
  return request({
    url: `novel_mini_release_report/bind_channel_t_report_update`,
    method: 'get',
    params
  })
}
// 更新123---小说站点
export function toUpdateNovelSite(params = {}) {
  return request({
    url: `novel_mini_release_report/site/bind_channel_t_report_update`,
    method: 'get',
    params
  })
}
// 投放组组长列表123
export function launchTeamLeader(params = {}) {
  return request({
    url: `/channel_release_report/release_group_leader`,
    method: 'get',
    params
  })
}
// 投放组组长列表123 ---小说
export function launchTeamLeaderNovle(params = {}) {
  return request({
    url: `/novel_mini_release_report/release_group_leader`,
    method: 'get',
    params
  })
}
// 飞书用户列表
export function feishuuserlist(params = {}) {
  return request({
    url: `/release_report/feishu_user`,
    method: 'get',
    params
  })
}
// 分组导出
export function bindwechatreportnew(params = {}) {
  return request({
    url: `/channel_release_report/bind_channel_report_new`,
    method: 'get',
    params
  })
}
// 分组导出===小说
export function bindwechatreportnewNovel(params = {}) {
  return request({
    url: `/novel_mini_release_report/bind_channel_report_new`,
    method: 'get',
    params
  })
}
// 分组导出===小说站点
export function bindwechatreportnewNovelSite(params = {}) {
  return request({
    url: `/novel_mini_release_report/site/bind_channel_report_new`,
    method: 'get',
    params
  })
}
// 导出报表123--小说站点
export function exportbinddataadvertiser(data = {}) {
  return request({
    url: `/novel_mini_release_report/site/export_bind_data_advertiser`,
    method: 'post',
    data
  })
}
